function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;


//////////////////
// WEBPACK FOOTER
// /Users/akshetpandey/workspace/thriller-server/~/@babel/runtime/helpers/builtin/setPrototypeOf.js
// module id = 582
// module chunks = 168707334958949